<template>
  <div v-if="user.id">
    <NewService />
  </div>
</template>

<script>
import NewService from '@/components/service/new-service.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    NewService
  },
  created () {
  },
  watch: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  data: function() {
    return { }
  },
}
</script>
